import UserTransformer from '@/transformers/users'
import Vue from 'vue'

/**
 * @author Suhipney R. <suhiipney@gmail.com>
 *
 * @param payload user to update
 *
 * Update an existing user
 * @return {Object} Updated user info
 */

export default (payload) =>
  Vue.$http.put(`/users/${payload.username}/`, UserTransformer.send(payload))
    .then((res) => UserTransformer.fetch(res.data))
